import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const rupiah = (n) =>
  "Rp " + Math.round(Number(n || 0)).toLocaleString("id-ID");

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_santri-billing-1/artifacts/xrup5ox1_logo%20ma%27had%20warna_tanpa%20latar.png";

export const fileUrl = (path) =>
  path ? `${BACKEND_URL}/api/files/${path}?token=${localStorage.getItem("token") || ""}` : null;

export async function downloadReport(path, params, filename) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const FEE_TYPES = [
  { value: "bulanan", label: "Biaya Bulanan Santri" },
  { value: "kitab", label: "Biaya Kitab" },
  { value: "bsb", label: "Biaya Santri Baru (BSB)" },
  { value: "seragam", label: "Biaya Seragam Santri" },
  { value: "kegiatan", label: "Biaya Kegiatan Santri" },
];

export const SERAGAM = ["Seragam Batik", "Seragam Putih Biru", "Seragam Pramuka", "Seragam Silat"];
